import script from "./PriceingUseAdo.vue?vue&type=script&lang=ts&setup=true"
export * from "./PriceingUseAdo.vue?vue&type=script&lang=ts&setup=true"

import "./PriceingUseAdo.vue?vue&type=style&index=0&id=44e23256&lang=scss"

const __exports__ = script;

export default __exports__